<template>
  <div class="SpedAjusteC197 container">

    <h3>SPED - Ajuste C197</h3>
    <hr/>

    <b-modal :visible="processando" hide-header hide-footer centered>
      <div>Processando...</div>
    </b-modal>


    <b-form v-on:submit.prevent="gerarSped">


      <b-form-group>
        <label for="sped">Arquivo SPED
          <span class="text-danger">*</span>
        </label>
        <b-file id="sped" name="sped" accept=".sped, .txt" required/>
      </b-form-group>

      <b-btn type="submit" variant="success" :disabled="processando" ref="submitForm">Ajustar SPED</b-btn>
    </b-form>
  </div>
</template>

<script>

import Sped from '@/libs/sped'
import { readAsText } from '@/libs/utils'
import iconv from 'iconv-lite'
import FileSaver from 'file-saver'
import uuid4 from 'uuid4'

const splitLines = (text) => text.split(/\n|\r\n/)

export default {
  data () {
    return {
      processando: false,
    }
  },
  methods: {
    gerarSped: async function (event) {
      await this.$nextTick(async () => {
        this.$set(this.$data, 'processando', true)
      })
      const file = event.target.sped.files[0]
      const text = await readAsText(file)

      const data = await this.$worker.run(splitLines, [text])
      const lines = await this.$worker.run((lines) => lines.filter(l => l.startsWith('|')), [data])
      const sped = new Sped(lines)

      sped.ajustaC197()

      const ajustado = sped.getSped()

      setTimeout(() => {
        this.$set(this.$data, 'processando', false)
        // console.log(ajustado)

        const buf = iconv.encode(ajustado, 'win1252')

        const blob = new Blob([buf], {
          type: 'application/octet-stream',
        })

        FileSaver.saveAs(blob, `${uuid4()}.txt`)

      }, 200)

    },
  },
}
</script>
